<template>
  <div>
    <div class="m-subheader">
      <div class="mr-subheader-box">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <span class="subheader-icon">
              <i class="m-menu__link-icon flaticon-line-graph"></i>
            </span>
            <h3 class="m-subheader__title">Rol</h3>
          </div>
          <div></div>
        </div>
      </div>
    </div>

    <div class="m-content">
      <div class="row">
        <div class="col-lg-12">
          <!--begin::Portlet-->
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    <a
                      :href="'#/roles'"
                      class="btn btn-sm btn-secondary m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill m--margin-right-10"
                    >
                      <i class="la la-angle-left"></i>
                    </a>
                    Rol Ekle
                  </h3>
                </div>
              </div>
            </div>

            <!--begin::Form-->
            <form class="m-form m-form--fit m-form--label-align-right">
              <div class="m-portlet__body m-form-box-cont">
                <div class="form-group m-form__group row">
                  <div class="col-lg-12">
                    <label>Ad</label>
                    <input
                      type="text"
                      :class="{ 'is-invalid': $v.role.name.$error }"
                      v-model="role.name"
                      class="form-control m-input"
                      placeholder="Rol Adı."
                    />
                  </div>
                  <div class="col-lg-12">
                    <label>Yetkiler</label>
                    <treeselect
                      v-model="roleAuthority.authorities"
                      value-consists-of="LEAF_PRIORITY"
                      placeholder="Yetkiler"
                      :multiple="true"
                      :options="optionsA"
                      :always-open="false"
                    />
                  </div>
                  <div class="col-lg-12">
                    <label>Kullanıcılar</label>
                    <treeselect
                      v-model="roleUser.users"
                      value-consists-of="LEAF_PRIORITY"
                      placeholder="Kullanıcılar"
                      :multiple="true"
                      :options="optionsU"
                      :always-open="false"
                    />
                  </div>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
                <div class="m-form__actions m-form__actions--solid">
                  <div class="row">
                    <div class="col-lg-12">
                      <button
                        type="button"
                        @click="role.id==0?create():update()"
                        class="spbtn"
                      >Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!--end::Form-->
          </div>

          <!--end::Portlet-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import {
  _getById,
  _create,
  _update,
  _getAuthoritiesByRole,
  _getSystemAuthorities,
  _updateRoleAuthorities,
  _updateRoleUsers,
  _getRoleUsers
} from "../../services/RoleService";
import { _getAll } from "../../services/UserService";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  data() {
    return {
      role: {
        id: 0,
        name: ""
      },
      roleAuthority: {
        roleId: 0,
        authorities: []
      },
      roleUser: {
        roleId: 0,
        users: []
      },
      optionsA: [],
      optionsU: []
    };
  },
  components: { Treeselect },
  created() {
    if (Number(this.$route.params.id) != 0) {
      this.role.id = Number(this.$route.params.id);
      this.getById();
      this.roleAuthority.roleId = this.role.id;
      this.roleUser.roleId = this.role.id;
      this.getRoleAuthorities();
      this.getRoleUsers();
    }
    this.getSystemAuthorities();
    this.getUsers();
  },
  validations: {
    role: {
      name: { required }
    }
  },
  methods: {
    getById() {
      _getById(this.role.id).then(res => {
        if (res.data.success) this.role = res.data.data;
      });
    },
    create() {
      this.$v.role.$touch();
      if (this.$v.role.$error) return;

      _create(this.role).then(res => {
        if (res.data.success) {
          this.roleAuthority.roleId = res.data.data;
          this.roleUser.roleId = res.data.data;

          this.updateRoleAuthorities();
          this.updateRoleUsers();
        }
      });
    },
    update() {
      this.$v.role.$touch();
      if (this.$v.role.$error) return;

      _update(this.role).then(res => {
        if (res.data.success) this.updateRoleAuthorities();
        this.updateRoleUsers();
      });
    },
    getSystemAuthorities() {
      _getSystemAuthorities().then(res => {
        this.optionsA = res.data;
      });
    },
    getRoleAuthorities() {
      _getAuthoritiesByRole(this.roleAuthority.roleId).then(res => {
        if (res.data.success) this.roleAuthority.authorities = res.data.data;
      });
    },
    updateRoleAuthorities() {
      _updateRoleAuthorities(this.roleAuthority).then(res => {});
    },
    getUsers() {
      _getAll().then(res => {
        res.data.data.items.forEach(item => {
          this.optionsU.push({ id: item.id, label: item.fullName });
        });
      });
    },
    updateRoleUsers() {
      _updateRoleUsers(this.roleUser).then(res => {
        if (res.data.success) this.$router.push({ name: "roles" });
      });
    },
    getRoleUsers() {
      _getRoleUsers(this.roleUser.roleId).then(res => {
        res.data.data.forEach(item => {
          this.roleUser.users.push(item.id);
        });
      });
    }
  }
};
</script>